import axios from "axios";
import { get as lodashGet, isArrayBuffer } from "lodash";
import { ajaxEnd, ajaxFail, ajaxStart, ajaxSuccess } from "src/actions/ajax";

import { host } from "../config";

const AJAX_TIMEOUT = 58000;
const BASE_URL = `${host}/line`;
const AJAX_END_TIMEOUT = 700;

const arraybufferToJson = (arraybuffer) => {
  try {
    const str = String.fromCharCode.apply(null, new Uint8Array(arraybuffer));
    const json = JSON.parse(str);
    return json;
  } catch (e) {
    return undefined;
  }
};

let reduxStore;
export function initAxiosClient(store) {
  axios.defaults.headers.post["Content-Type"] = "application/json";
  reduxStore = store;
}

export function getAxiosClient(
  storeKey = "",
  opt = { hideError: false, hideLoading: false }
) {
  const { hideError, hideLoading } = opt;
  // const headers = {};

  const axiosClient = axios.create({
    baseURL: BASE_URL,
    timeout: AJAX_TIMEOUT,
    //headers
  });

  axiosClient.interceptors.request.use(
    (config) => {
      if (!hideLoading) reduxStore.dispatch(ajaxStart(storeKey));
      return config;
    },
    (err) => {
      return Promise.reject(err);
    }
  );

  axiosClient.interceptors.response.use(
    (res) => {
      if (!hideLoading) {
        // setTimeout(() => {
        //   reduxStore.dispatch(ajaxEnd(storeKey));
        // }, AJAX_END_TIMEOUT);
      }

      if (storeKey) {
        reduxStore.dispatch(ajaxSuccess(storeKey, res.data));
      }
      return res;
    },
    (err) => {
      const defaultMessage = "Network Issue";
      // capture error object to fulfill all error condition
      let errorData = lodashGet(err, ["response", "data"]);
      if (isArrayBuffer(errorData)) {
        errorData = arraybufferToJson(errorData);
      }
      const error = lodashGet(errorData, "err", defaultMessage);

      if (!hideError) {
        // show error message banner
      }

      if (!hideLoading) {
        setTimeout(() => {
          reduxStore.dispatch(ajaxEnd(storeKey));
        }, AJAX_END_TIMEOUT);
      }

      if (err.response && err.response.status === 401) {
        // access deined
      }

      if ((storeKey, !hideError)) {
        reduxStore.dispatch(ajaxFail(storeKey));
      }
      throw err;
    }
  );

  return axiosClient;
}
